import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api/logs/';

class LogService {
    getIssueLogs(id) {
        return axioscommon.get(API_URL + id, { headers: authHeader() });
    }
    getLogs() {
        return axioscommon.get(API_URL, { headers: authHeader() });
    }
}

export default new LogService();
